import type { Exam, Question } from '../types'

const KEY = 'sangmath-dgnl-practice-session-v1'

export type StoredPracticeSession = {
  exam: Exam | 'ALL'
  topic: string
  questions: Question[]
  index: number
  createdAt: string
}

export function loadPracticeSession(): StoredPracticeSession | null {
  try {
    const value = JSON.parse(sessionStorage.getItem(KEY) || 'null') as Partial<StoredPracticeSession> | null
    if (!value || !Array.isArray(value.questions) || !value.questions.length || typeof value.index !== 'number' || !Number.isInteger(value.index)) return null
    if (value.index < 0 || value.index >= value.questions.length) return null
    if (value.exam !== 'ALL' && value.exam !== 'HSA' && value.exam !== 'VACT' && value.exam !== 'TSA') return null
    if (typeof value.topic !== 'string') return null
    return value as StoredPracticeSession
  } catch {
    return null
  }
}

export function savePracticeSession(session: StoredPracticeSession) {
  try {
    sessionStorage.setItem(KEY, JSON.stringify(session))
  } catch {
    // Session resume is progressive enhancement; practice must never fail if
    // browser storage is disabled or full.
  }
}

export function clearPracticeSession() {
  try { sessionStorage.removeItem(KEY) } catch { /* no-op */ }
}
